/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';

const CustomLabelInput = styled.textarea`
	width: 100%;
	min-height: 50px;
	padding: 5px;
	border: none;
	border-radius: 5px;
	outline: 0;
	resize: none;
	font-size: 20px;
	color: color: #686871;
`;

const CustomLabel = ({handleChange, value}) => (
    <CustomLabelInput
        name="custom-label"
        id="custom-label"
        onChange={handleChange}
        value={value}
    >
    </CustomLabelInput>
);

export default CustomLabel;



// WEBPACK FOOTER //
// ./src/containers/disponent/customLabel.js